import _ from 'lodash'

const keyOrder = [
  'nationality',
  'gender',
  'age',
  'location',
  'work_right',
  'study_right',
  'experience',
  'qualifications',
  'professional_qualifications',
]

export const EligibilityChecklist = {
  data() {
    return {
      modifiedRequirements: [],
    }
  },

  computed: {
    eligibility() {
      return this.$store.getters['candidate/eligibilities/forOpportunity'](this.opportunity.id)
    },

    requirementGroups() {
      if (!_.get(this, 'eligibility.requirementGroups[0]')) return []

      return _.get(this, 'eligibility.requirementGroups')
    },

    qualificationGroups() {
      if (!_.get(this, 'requirementGroups[0]')) return []

      return this.requirementGroups.filter(g => g.type === 'ProfileQualificationRequirementGroup')
    },

    checklist() {
      return _.get(this, 'eligibility.checklist')
    },

    requirementsChecklist() {
      if (!this.checklist) return []

      let list = JSON.parse(JSON.stringify(this.checklist))
      list = Object.keys(list)
        .filter(
          key =>
            !key.match(/^(experience|qualification|work_experience).*$/) &&
            this.isARequirement(list[key])
        )
        .map(key => ({ key: key, ...list[key] }))
      if (this.experienceRequirement) list.push(this.experienceRequirement)
      if (this.qualificationsRequirement) list.push(this.qualificationsRequirement)
      if (this.professionalQualificationsRequirement) {
        list.push(this.professionalQualificationsRequirement)
      }

      return list.sort((a, b) => keyOrder.indexOf(a.key) - keyOrder.indexOf(b.key))
    },

    experienceRequirement() {
      const required = Object.keys(this.checklist).some(key => key.includes('experience'))
      const possible = Object.keys(this.checklist).some(key => {
        return (
          key.match(/^experience.*$/) && _.get(this.checklist, `[${key}].status`) === 'possible'
        )
      })

      if (required) {
        return {
          key: 'experience',
          type: 'requirement',
          status: possible ? 'possible' : 'missing',
        }
      }
    },

    qualificationsRequirement() {
      const required = Object.keys(this.checklist).some(key => key.includes('qualification'))
      const possible = Object.keys(this.checklist).some(key => {
        return (
          key.match(/^qualification.*$/) && _.get(this.checklist, `[${key}].status`) === 'possible'
        )
      })

      if (required) {
        return {
          key: 'qualifications',
          type: 'requirement',
          status: possible ? 'possible' : 'missing',
        }
      }
    },

    professionalQualificationsRequirement() {
      if (_.get(this,'professionalQualificationRequirementsGroups[0]')) {
        const satisfied = !this.professionalQualificationRequirementsGroups.some(group => !group.satisfied)
        return {
          key: 'professional_qualifications',
          type: 'requirement',
          status: satisfied ? 'satisfied' : 'missing',
        }
      }
    },

    professionalQualificationRequirementsGroups() {
      return this.qualificationGroups.filter(g => {
        return (
          g.requirements &&
          g.requirements.some(r => {
            return (
              _.get(r, 'qualificationCategory.name') === 'Professional Qualification' ||
              _.get(r, 'qualificationType.qualificationCategory.name') ===
                'Professional Qualification'
            )
          })
        )
      })
    },

    hasIncompleteRequirements() {
      if (!this.checklist) return false

      return !!this.incompleteRequirements[0]
    },

    incompleteRequirements() {
      if (!this.checklist) return false

      const list = JSON.parse(JSON.stringify(this.requirementsChecklist))
      return list.filter(
        req => !this.isRequirementSatisfied(req) && !this.isRequirementModified(req)
      )
    },

    nextIncompleteRequirement() {
      if (!this.hasIncompleteRequirements) return -1

      const list = JSON.parse(JSON.stringify(this.requirementsChecklist))
      return list.findIndex(
        req => !this.isRequirementSatisfied(req) && !this.isRequirementModified(req)
      )
    },

    checklistProgress() {
      if (!this.checklist || !this.hasIncompleteRequirements) return 100

      return (this.incompleteRequirements.length / Object.keys(this.checklist).length) * 100
    },
  },

  methods: {
    isARequirement(requirement) {
      return _.get(requirement, 'type') === 'requirement'
    },

    isRequirementModified(requirement) {
      return this.modifiedRequirements.some(modified => requirement.key === modified.key)
    },

    isRequirementSatisfied(requirement) {
      return ['satisfied', 'possible'].includes(_.get(requirement, 'status'))
    },

    pushModifiedRequirement(requirement) {
      if (!this.isRequirementModified(requirement)) {
        const key = Object.keys(requirement)[0]
        this.modifiedRequirements.push({ [key]: requirement[key] })
      }
    },

    requirementColor(requirement) {
      if (this.isRequirementSatisfied(requirement) || this.isRequirementModified(requirement)) {
        return this.themes.candidate.light.success
      }
      return this.themes.candidate.light.warning
    },
  },
}

export default { EligibilityChecklist }
